import type { TFunction } from 'next-i18next'
import { ProjectKindType } from 'src/core/models'
import ProjectCertificationCentralName from './ProjectCertificationCentralName/ProjectCertificationCentralName'
import ProjectCertificationComplementaryStandards from './ProjectCertificationComplementaryStandards/ProjectCertificationComplementaryStandards'
import ProjectCertificationCreditDates from './ProjectCertificationCreditDates/ProjectCertificationCreditDates'
import ProjectCertificationEnergySourceType from './ProjectCertificationEnergySourceType/ProjectCertificationEnergySourceType'
import ProjectCertificationMechanism from './ProjectCertificationMechanism/ProjectCertificationMechanism'
import ProjectCertificationMethdology from './ProjectCertificationMethdology/ProjectCertificationMethdology'
import ProjectCertificationQuantificationMethodology from './ProjectCertificationQuantificationMethodology/ProjectCertificationQuantificationMethodology'
import ProjectCertificationStageFormItem from './ProjectCertificationStageFormItem/ProjectCertificationStageFormItem'
import ProjectCertificationStandardSelect from './ProjectCertificationStandardSelect/ProjectCertificationStandardSelect'
import ProjectCertificationStandardType from './ProjectCertificationStandardType/ProjectCertificationStandardType'
import ProjectCertificationStatus from './ProjectCertificationStatus/ProjectCertificationStatus'
import ProjectCertificationSubType from './ProjectCertificationSubType/ProjectCertificationSubType'
import ProjectCertificationType from './ProjectCertificationType/ProjectCertificationType'
import ProjectCertificationTypeOfBiome from './ProjectCertificationTypeOfBiome/ProjectCertificationTypeOfBiome'
import ProjectCertificationValidator from './ProjectCertificationValidator/ProjectCertificationValidator'
import ProjectCertificationVerifier from './ProjectCertificationVerifier/ProjectCertificationVerifier'


export const certificationSections = (t: TFunction, kindSelected: ProjectKindType) => [
  { // Status
    isVisible: kindSelected !== 'carbon_forward',
    component: ProjectCertificationStatus,
    labels: {
      title: t('Projects.Fields.Status'),
      subtitle: t('Projects.Form.StatusLabel')
    }
  },

  { // Stage
    isVisible: kindSelected === 'carbon_forward',
    component: ProjectCertificationStageFormItem,
    labels: {
      title: t('Forward.Stage'),
      subtitle: t('Forward.StageLabel')
    }
  },

  { // Type of biome ecosystem
    isVisible: kindSelected === 'biodiversity',
    component: ProjectCertificationTypeOfBiome,
    labels: {
      title: t('Projects.TypeOfBiome'),
      subtitle: t('Projects.TypeOfBiomeLabel')
    }
  },

  { // Type
    isVisible: ['compensation', 'carbon_forward'].includes(kindSelected),
    component: ProjectCertificationType,
    labels: {
      title: t('Projects.Fields.Type'),
      subtitle: t('Projects.Form.TypeLabel')
    }
  },

  { // SubType
    isVisible: ['compensation', 'carbon_forward'].includes(kindSelected),
    component: ProjectCertificationSubType,
    labels: {
      title: t('Projects.Fields.SubType'),
      subtitle: t('Projects.Form.SubtypeLabel')
    }
  },

  { // Methdology
    isVisible: ['compensation', 'biodiversity', 'carbon_forward'].includes(kindSelected),
    component: ProjectCertificationMethdology,
    labels: {
      title: t('Projects.Fields.Methodology'),
      subtitle: t('Projects.Form.MethodologyLabel')
    }
  },

  { // Quantification Methodology
    isVisible: ['compensation', 'carbon_forward'].includes(kindSelected),
    component: ProjectCertificationQuantificationMethodology,
    labels: {
      title: t('Projects.Form.QuantificationMethodology'),
      subtitle: t('Projects.Form.QuantificationMethodologyLabel')
    }
  },

  { // Mechanism
    isVisible: ['compensation', 'carbon_forward'].includes(kindSelected),
    component: ProjectCertificationMechanism,
    labels: {
      title: t('Projects.Fields.Mechanism'),
      subtitle: t('Projects.Fields.MechanismLabel')
    }
  },

  { // Energy Source Type
    isVisible: kindSelected === 'energy',
    component: ProjectCertificationEnergySourceType,
    labels: {
      title: t('Projects.Fields.EnergySourceTypeTwo'),
      subtitle: t('Projects.Form.SourceTypeLabel')
    }
  },

  { // Generation Cerntral Name
    isVisible: kindSelected === 'energy',
    component: ProjectCertificationCentralName,
    labels: {
      title: t('Projects.Fields.GenerationCentralName'),
      subtitle: t('Projects.Form.CentralNameLabel')
    }
  },

  { // Energy Standard Type
    isVisible: kindSelected === 'energy',
    component: ProjectCertificationStandardType,
    labels: {
      title: t('Projects.Fields.StandardType'),
      subtitle: t('Projects.Form.StandardTypeLabel')
    }
  },

  { // Validator
    isVisible: true,
    component: ProjectCertificationValidator,
    labels: {
      title: t('Projects.Fields.Validator'),
      subtitle: t('Projects.Form.ValidatorLabel')
    }
  },

  { // First Verifier
    isVisible: kindSelected !== 'biodiversity',
    component: ProjectCertificationVerifier,
    labels: {
      title: t('Projects.Fields.FirstVerifier'),
      subtitle: t('Projects.Form.FirstVerifyerLabel')
    }
  },

  { // Standard
    isVisible: ['compensation', 'biodiversity', 'carbon_forward'].includes(kindSelected),
    component: ProjectCertificationStandardSelect,
    labels: {
      title: t('Projects.Fields.Standard'),
      subtitle: t('Projects.Form.StandardLabel')
    }
  },

  { // Complementary Standards
    isVisible: ['compensation', 'carbon_forward'].includes(kindSelected),
    component: ProjectCertificationComplementaryStandards,
    labels: {
      title: t('Projects.Form.ComplementaryStandards'),
      subtitle: t('Projects.Form.ComplementaryStandardsLabel')
    }
  },

  { // Credit Dates
    isVisible: ['compensation', 'biodiversity', 'carbon_forward'].includes(kindSelected),
    component: ProjectCertificationCreditDates,
    labels: {
      title: kindSelected === 'carbon_forward' ? t('Forward.DateLabel') : t('Projects.Fields.CreditDates'),
      subtitle: kindSelected === 'carbon_forward' ? t('Forward.DateSubLabel') : t('Projects.Form.CreditDatesPlaceholder')
    }
  }
]
